import { Button, Typography } from "@mui/material";
import { Fragment, useState } from "react";

import "../../details components/nodes.css";
import ActionDrawer from "../add action components/ActionDrawer";

export default function NoSelection({ actions, formikProps, setNewAction }) {
  const [openDrawer, setOpenDrawer] = useState({ state: false, data: {} });

  return (
    <Fragment>
      <Typography variant="h5">Instant No Action</Typography>

      {!!formikProps.values.noActions && (
        <Typography variant="h5" fontSize={"15px"}>
          Action - {handleShowAction("noActions")}
        </Typography>
      )}

      <div style={{ width: "100%" }}>
        <Button
          onClick={() => setOpenDrawer({ state: true, data: {}, action: "no" })}
          variant="contained"
          style={{ float: "right" }}
        >
          Add Action
        </Button>
      </div>

      <ActionDrawer
        setNewAction={setNewAction}
        actions={actions}
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        formikProps={formikProps}
      />
    </Fragment>
  );

  function handleShowAction(act) {
    let acts = actions.filter(
      (action) => action._id === formikProps.values[act]
    );

    return acts[0] ? acts[0].action_name : "None";
  }
}
